<span class="pi-container"
      [ngClass]="method || ''"></span>
